import classNames from "classnames";
import Link from "next/link";
import { useSelector } from "react-redux";

import { getDomainCountryCode } from "redux/selectors/config";
import { dispensaryHref } from "utils/dispensaryUrls";

type Props = {
  slug: string;
  onClick?: () => void;
  className?: string;
  retailType?: string;
};

const WriteDispensaryReviewButton = ({
  slug,
  onClick = () => false,
  className = "",
  retailType,
}: Props): JSX.Element => {
  const countryCode = useSelector(getDomainCountryCode);

  const href = dispensaryHref({
    additionalPath: "/write-review",
    countryCode,
    retailType,
    slug,
  });

  return (
    <Link
      prefetch={false}
      href={href}
      className={classNames(className, "button button--secondary ")}
      data-testid="write-review-button"
      onClick={onClick}
    >
      write a review
    </Link>
  );
};

export default WriteDispensaryReviewButton;
